const scope_0 = require('/home/travis/build/JSConfBp/2019.jsconfbp.com/.cache/caches/gatsby-mdx/mdx-scopes-dir/0cb2e5203075442c9b96356e1cd3b680.js').default;
const scope_1 = require('/home/travis/build/JSConfBp/2019.jsconfbp.com/.cache/caches/gatsby-mdx/mdx-scopes-dir/1970366a8c100bb8e42caab4bfa24659.js').default;
const scope_2 = require('/home/travis/build/JSConfBp/2019.jsconfbp.com/.cache/caches/gatsby-mdx/mdx-scopes-dir/9e9b4a0cca919a0020745c1be72e2556.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    